import {FC} from 'react';
import {Navigate, Route, Routes, useLocation} from 'react-router';
import {ROUTES} from 'core';

import {LiveChatScene} from './LiveChatScene';
import {DocumentsScene} from './DocumentsScene';
import {ConnectionsScene} from './ConnectionsScene';
import {PersonalizationScene} from './PersonalizationScene';
import {DownloadChatScene} from './DownloadChatScene';
import {MemoryScene} from './MemoryScene';
import {AgentTasksScene} from './AgentTasksScene';
import {MsgInspectorScene} from './MsgInspectorScene';
import {OAuthCallbackScene} from './OAuthCallbackScene';
import {Error503Scene} from './SystemScenes';

/* ALL ROUTES */
export const AppRouter: FC = () => {
  const location = useLocation();

  const state = location.state as {background?: Location};
  const mainLocation = state?.background ?? location;

  return (
    <>
      <Routes location={mainLocation}>
        <Route path={ROUTES.Chat.Root} element={<LiveChatScene />} />
        <Route path={ROUTES.OAuth.AuthCallback} element={<OAuthCallbackScene />} />
        <Route path={ROUTES.System.Error503} element={<Error503Scene />} />
        <Route path="*" element={<Navigate to={ROUTES.Chat.Root} replace />} />
      </Routes>

      {state?.background && (
        <Routes>
          <Route path={ROUTES.Modal.Documents} element={<DocumentsScene />} />
          <Route path={ROUTES.Modal.Connections} element={<ConnectionsScene />} />
          <Route path={ROUTES.Modal.Personalization} element={<PersonalizationScene />} />
          <Route path={ROUTES.Modal.DownloadChat} element={<DownloadChatScene />} />
          <Route path={ROUTES.Modal.Memory} element={<MemoryScene />} />
          <Route path={ROUTES.Modal.AgentTasks} element={<AgentTasksScene />} />
          <Route path={ROUTES.Modal.MsgInspector} element={<MsgInspectorScene />} />
        </Routes>
      )}
    </>
  );
};
